/**
 * This is a adjusted IconBase component from phosphor-react. We use that to format our own phospor icons.
 */

import { forwardRef } from 'react';
import { IconProps } from './types';

interface IconBaseProps extends IconProps {
  viewBoxBase?: number;
  /**
   * Zoom into the icon by X pixels. This is used to adjust the TMH icon's size to phosphor-react.
   */
  zoom?: number;
}

export type CustomIconWeight = 'thin' | 'light' | 'regular' | 'bold';

const IconBase = forwardRef<SVGSVGElement, IconBaseProps>(
  ({ color = 'currentColor', size, viewBoxBase = 256, zoom = 0, mirrored, alt, children, isSmall, ...props }, ref) => {
    if (isSmall) {
      zoom = -40;
    }
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        fill={color}
        viewBox={`${zoom} ${zoom} ${viewBoxBase - zoom * 2} ${viewBoxBase - zoom * 2}`}
        transform={mirrored ? 'scale(-1, 1)' : undefined}
        {...props}>
        {!!alt && <title>{alt}</title>}
        {children}
      </svg>
    );
  }
);

IconBase.displayName = 'IconBase';

export default IconBase;
